import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { SurvivorNew } from './SurvivorNew'

const WrappedSurvivorNew = withLayout(LayoutType.Default, SurvivorNew)

export { WrappedSurvivorNew as SurvivorNew }
